import Service from '../../services/FaxChannelsService';
import RequestList from "../../services/RequestList";

const state = {
    sentRequestCount: 0,
    items : []
}

const getters = {
    fetching(state) {
        return state.sentRequestCount > 0;
    },
    keyedById(state){
        let itemsKeyById = {};

        state.items.forEach(item => {
            itemsKeyById[item.id] = item;
        });

        return itemsKeyById;
    }
}

const mutations = {
    SET_ITEMS(state, items) {
        state.items = items;

    },
    INCREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount++;
    },
    DECREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount--;
    }
}

const actions = {
    async sync({ commit }) {
        commit('INCREMENT_SENT_REQUEST_COUNT');

        try {
            let requestList = new RequestList();
            let {
                data
            } = await Service.list(requestList);

            commit('SET_ITEMS', data.value.fax_channels);
        } finally {
            commit('DECREMENT_SENT_REQUEST_COUNT');
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}